  <div class="custom-theme-modal modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content modal-scrollable-content">
      <div class="modal-header d-block py-3 border-bottom">
        <div class="row">
          <div class="col-7 pr-0">
            <h6 class="heading-3">
              <span class="cursor-pointer"
              (click)="nextPostScreen.next(0)">
                <img class="pb-1" src="assets/themes/icons/back-arrow.svg" alt="back">
              </span>
              {{mls.languageText.create_post_drafts.key1}}
              <span *ngIf="mls?.is_lskey_display==1">(create_post_drafts.key1)</span>
            </h6>
          </div>
        </div>
      </div>

      <div>
        <div class="ps position-relative p-4 post-draft-list" [perfectScrollbar]="config">
          <!-- with media -->
          <div class="paragraph-bold text-center mt-5 mb-5" *ngIf="dss.postDraftData.length==0">
            {{mls.languageText.create_post_drafts.key2}}
            <span *ngIf="mls?.is_lskey_display==1">(create_post_drafts.key2)</span>
          </div>
          <div class="border rounded mt-2" *ngFor="let draftdata of dss.postDraftData; let idx=index">
            <div class="bg-white p-3 mt-1">
              <div class="row">
                <div
                  [ngClass]="{'col-12':draftdata?.screen1?.media.length==0,  'col-9':draftdata?.screen1?.media.length>0}">
                  <!-- {{draftdata | json}} -->
                  <app-content-card [cmt]="draftdata?.screen1?.content" [callingfrom]="'postdraft'" [showChar]="150"
                    [isActionBlock]=true>
                  </app-content-card>
                  <p class="secondary-paragraph mt-2">
                    <span class="color-grey-500">
                      {{draftdata?.creation_time | date:'MMM dd, yyyy, h:mm a'}}
                    </span>
                  </p>
                </div>

                <div class="col-3 pl-0" *ngIf="draftdata?.screen1.media.length>0">
                  <div class="rounded text-right">
                    <img class="rounded" [src]="draftdata?.screen1.media[0].local | safeurl" width="100" height="100"></div>
                </div>
              </div>
            </div>
            <div class="bg-white p-2 mb-1">
              <div class="row">
                <div class="col-6 text-center">
                  <button type="button" class="btn-design outline small w-100" (click)="deleteFromDraft(idx)">
                    <svg id="Layer_1" data-name="Layer 1" style="margin-top: -5px;"
                      class="mr-1" width="17px" viewBox="0 0 24 24">
                      <defs>
                        <style>
                          .delete-option-post {
                            fill: var(--black-color);
                          }

                          .delete-option-post2,
                          .delete-option-post3 {
                            fill: none;
                            stroke-linecap: round;
                            stroke-linejoin: round;
                          }

                          .delete-option-post2 {
                            stroke: var(--black-color);
                          }

                          .delete-option-post3 {
                            stroke: var(--white-color);
                          }
                        </style>
                      </defs>
                      <path class="delete-option-post"
                        d="M19.85,7.31v14A1.65,1.65,0,0,1,18.19,23H5.81a1.65,1.65,0,0,1-1.66-1.65v-14Z" />
                      <line class="delete-option-post2" x1="1.43" y1="4.99" x2="22.57" y2="4.99" />
                      <path class="delete-option-post2"
                        d="M10.42,1H14a3,3,0,0,1,3,3V5a0,0,0,0,1,0,0H7.42a0,0,0,0,1,0,0V4A3,3,0,0,1,10.42,1Z" />
                      <line class="delete-option-post3" x1="9.41" y1="9.99" x2="9.41" y2="19.96" />
                      <line class="delete-option-post3" x1="14.59" y1="9.99" x2="14.59" y2="19.96" />
                    </svg> {{mls.languageText.create_post_drafts.key3}}
                    <span *ngIf="mls?.is_lskey_display==1">(create_post_drafts.key3)</span>
                  </button>
                </div>
                <div class="col-6 text-center">
                  <button type="button" class="btn-design filled small w-100" (click)="editDraftData(idx)">
                    <svg id="Layer_1" class="mr-1" data-name="Layer 1" width="15px"
                      style="margin-top: -5px;" viewBox="0 0 16 16">
                      <defs>
                        <style>
                          .edit-post {
                            fill: var(--white-color);;
                          }
                        </style>
                      </defs>
                      <path class="edit-post"
                        d="M14,1a1.83,1.83,0,0,0-2.6,0L1.92,10.47a.24.24,0,0,0-.07.09,0,0,0,0,1,0,0s0,.06,0,.09v0L.54,14.78a.57.57,0,0,0,.13.55.53.53,0,0,0,.38.17.5.5,0,0,0,.17,0l4.07-1.25h0s.07,0,.09,0a0,0,0,0,0,0,0,.13.13,0,0,0,.09-.07l9.43-9.43a1.83,1.83,0,0,0,0-2.6Z" />
                    </svg>
                      {{mls.languageText.create_post_drafts.key4}}
                    <span *ngIf="mls?.is_lskey_display==1">(create_post_drafts.key4)</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>